function removeBladesForLife() {
  // this needs to be updated if the product changes
  const productIds = [7109867143248, 7114612605008, 7115400380496];

  const cart = window.liquidAjaxCart.cart;

  let cartHasRazors = false;
  let updates = {};
  
  if (cart && cart.items) {
    cart.items.forEach(item => {
      if (item.product_type === "Razor" || item.product_type === "Titanium Razor") {
        cartHasRazors = true;
      }

      if (productIds.includes(item.product_id)) {
        updates[item.key] = 0;
      }
    });
  }

  if (cartHasRazors) return;

  if (Object.keys(updates).length > 0) {
    return {
      requests: [
        {
          type: "update",
          body: {
            updates
          }
        }
      ]
    };
  }
}

function runWhenInit() {
  liquidAjaxCart.conf("quantityTagAllowZero", true);
  liquidAjaxCart.conf("mutations", [
    removeBladesForLife
  ]);
}

if (window.liquidAjaxCart?.init) {
  runWhenInit();
} else {
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

// --- VISUALS: Global Animation Handler ---
function getCartOverlay() {
  return document.querySelector('.cart-loading-overlay');
}

document.addEventListener('liquid-ajax-cart:request-start', function() {
  const overlay = getCartOverlay();
  if (overlay) overlay.classList.add('reveal-spinner');
});

document.addEventListener('liquid-ajax-cart:request-end', function() {
  const overlay = getCartOverlay();
  if (overlay) overlay.classList.remove('reveal-spinner');
});

// Keep this purely for immediate visual feedback on click
document.addEventListener('click', function(event) {
  const btn = event.target.closest('button[type="submit"], input[type="submit"]');
  if (btn) {
    const form = btn.closest('form[action^="/cart/add"]');
    if (form) {
      const overlay = getCartOverlay();
      if (overlay) overlay.classList.add('reveal-spinner');
      
      // Safety: Remove spinner after 5s
      setTimeout(() => {
        if (overlay) overlay.classList.remove('reveal-spinner');
      }, 5000);
    }
  }
});

/*****************************************
Makes add-to-cart forms and buttons open slideout cart
******************************************/
function atcSlideOutCart() {
  // Target ALL forms that look like cart forms
  const forms = document.querySelectorAll('form[action^="/cart/add"]');

  forms.forEach(form => {
    // grab the product variant ID from the form
    const products = form.querySelectorAll('input[name="id[]"]');

    form.addEventListener("submit", (event) => {
      // 1. STOP THE REDIRECT
      event.preventDefault();
      
      // 2. STOP THE DOUBLE ADD
      // This prevents the request from bubbling up to the library, 
      // so ONLY the manual request below fires.
      event.stopImmediatePropagation();

      // Build item list
      let items = []
      products.forEach(prod => {
        if (prod.checked || prod.type == "hidden") {
          items.push({ id: parseInt(prod.value), quantity: 1 })
        }
      });

      // Manually Add to Cart
      liquidAjaxCart.add({
        items: items
      });

      // Ensure Drawer Opens
      const bag = document.getElementById('bag');
      const trigger = document.querySelector('a[data-bs-toggle="offcanvas"][href="#bag"]');
      
      if (trigger) {
        // Only toggle if closed
        if (!bag || !bag.classList.contains('show')) {
          trigger.click();
        }
      }
    });
  });
}

// Run the function
atcSlideOutCart();